import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import AddSiblingActions, { AddSiblingRedux, AddSiblingTypes } from '../Redux/AddSiblingRedux'
import ClassroomActions from '../Redux/ClassroomRedux'
import { notificationSuccess } from '../Redux/NotificationActions'

const addSiblingCrudObservable = createCRUDObservable({
  mainRedux: AddSiblingRedux,
  reduxPath: 'addSibling',
})

const addSiblingEpic = (action$, store, { Api }) =>
  action$.ofType(AddSiblingTypes.addSiblingRequest)
    .mergeMap(({ studentId, data }) => (
      Observable
        .fromPromise(Api.addSibling.addSibling(studentId, data)
          .then(result => result)
          .catch(error => error))
        .flatMap((result) => {
          const { status } = result
          if (!(status >= 200 && status < 300)) {
            return [AddSiblingActions.addSiblingFailure(result.error)]
          }
          const { data: { data: payload } } = result
          return [
            AddSiblingActions.addSiblingSuccess(payload),
            ClassroomActions.updateStudentAfterAddSibling(payload),
            notificationSuccess('Hermano Agregado'),
          ]
        })
    ))


export const addSiblingObservers = Object.assign({}, addSiblingCrudObservable.observers, {
  addSiblingEpic,
})

export const addEpic = combineEpics(
  addSiblingEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/AddSiblingObservable.js